/** Match the same English or translated labels used to infer account pronouns. */
const isPronounsField = (name: string, localizedLabel: string): boolean => {
  const label = name.toLocaleLowerCase();
  return label.includes('pronouns') || label.includes(localizedLabel.toLocaleLowerCase());
};

export { isPronounsField };
